<template>
  <app-input-dlg
      :show-dialog="value"
      :show-input-box="false"
      :body-padding="false"
      :width="600"
  >
    <template slot="title">
      <div class="primary">
        <v-layout row align-center>
          <v-flex shrink class="body-1 white--text pa-2" style="white-space: nowrap">
            Othos Recordings
          </v-flex>
          <v-flex xs12 class="px-2 ">
            <v-text-field
                hide-details
                single-line
                dark
                prepend-icon="search"
                label="Search"
                class="pa-0 ma-0"
                color="white"
                v-model="searchStr"
            />
          </v-flex>
          <v-flex shrink class="px-2">
            <v-btn
                small
                icon
                flat
                class="pa-0 ma-0"
                color="white"
                @click="$emit('input', false)"
            >
              <v-icon small>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </template>
    <template slot="body">
      <v-divider></v-divider>
      <div v-if="loadingRecordings && recordings.length <= 0" style="width: 100%" class="text-xs-center">
        <v-progress-circular
            :size="40"
            :width="5"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="recordings.length" style="height: 400px; overflow-y: auto" class="c-d-flex fill-height of-y">
        <div class="c-flex-grow-1 of-y">
          <template v-for="rec in filteredCalls">
            <othos-recording
                :user-info="userInfo"
                :rec="rec"
                :selected-rec="selectedRec"
                @selectRecording="selectedRec = $event"
                :show-to="false"
            />
          </template>
        </div>
      </div>
    </template>
    <template slot="actions">
      <div style="width: 100%" class="text-xs-right">
        <v-btn
            :disabled="selectedRec == null"
            :loading="linkingToTask"
            small
            color="secondary"
            flat
            @click="linkRecordingToTask"
        >
          <v-icon left>link</v-icon>
          Link To Task
        </v-btn>
      </div>
    </template>
  </app-input-dlg>
</template>

<script>
import InputDlg from "../../../../components/General/InputDlg";
import {codeBaseMixin} from "../../../../codeBaseMixin";
import OthosRecording from "./OthosRecording.vue";
import {eventBus} from "../../../../main";

export default {
  mixins: [codeBaseMixin],
  components: {OthosRecording, appInputDlg: InputDlg},
  props: {
    userInfo: Object,
    taskID: Number,
    task: Object,
    stepID: Number,
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      recordings: [],
      loadingRecordings: false,
      selectedRec: null,
      linkingToTask: false,
      searchStr: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          eventBus.$emit('AudioPlay')
          this.searchStr = null;
          this.selectedRec = null;
          this.recordings = [];
          this.getCalls();
        }
      }
    }
  },

  methods: {

    linkRecordingToTask() {
      this.linkingToTask = true;
      this.fetch({
        method: 'POST', url: `/othos/linkRecordingToTask`, body: JSON.stringify({
          taskID: this.taskID,
          stepID: this.stepID,
          newFilename: `${this.selectedRecording.callfrom} - ${this.selectedRecording.callto}`,
          recording: this.selectedRecording.recording,
        })
      })
          .then((data) => {
            this.task.structure.documents.push(data)
            this.linkingToTask = false;
            this.$emit('addedDocument', false)
            this.$emit('input', false)
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
            this.linkingToTask = false;
          })
    },

    getCalls() {
      this.$nextTick(() => {
        this.loadingRecordings = true;

        this.fetch({
          method: 'GET',
          url: `/othos/recordingsList`
        })
            .then((data) => {
              this.recordings = data.map(row => ({...row, timestart: new Date(row.timestart)})).reverse();
              this.loadingRecordings = false;
            })
            .catch((e) => {
              // eslint-disable-next-line
              console.log(e)
              this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
              this.loadingRecordings = false;
            })
      })
    },


  },

  computed: {
    filteredCalls() {
      return this.recordings.filter(v => this.searchStr ? JSON.stringify(v).toLowerCase().includes(this.searchStr.toLowerCase()) : true)
    },
    selectedRecording() {
      try {
        return this.recordings.find(obj => obj.recording === this.selectedRec);
      } catch (e) {
        // eslint-disable-next-line
        return null
      }
    },
  },

}
</script>

<style scoped>

</style>
